import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { GiSpadeSkull } from "react-icons/gi";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatNumber } from "../../../utils/formatNumber";

const ProgressCard = ({ nowLevel, nowWash }) => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`vip.${key}`, { ...props });

  const vipList = useSelector((state) => state.isVipDetail);

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-[10px]">
        <div>
          <div className="w-[35px] h-[35px] relative">
            <CircularProgressbar
              className="!w-[35px]"
              styles={buildStyles({
                trailColor: "rgb(196 196 196) !important",
                pathColor: `rgba(${vipList[nowLevel + 1]?.lineBackground},1)`,
              })}
              strokeWidth={6}
              value={(nowWash / vipList[nowLevel + 1]?.wash_max) * 100}
            />
            <img
              src={vipList[nowLevel + 1]?.icon}
              className="absolute absolute-center text-[#9D9D9D] w-[21px] h-[21px] text-2xl object-scale-down"
              alt="vipIcon"
            />
          </div>
        </div>
        <span className="text-xl text-transaction-card-text dark:text-base-light-white font-medium">
          {i18n("Steel")}
        </span>
      </div>
      <span className="text-transaction-card-text dark:text-base-light-white tracking-tighter font-medium text-lg">
        {formatNumber(nowWash, { point: false })} /{" "}
        {formatNumber(vipList[nowLevel + 1]?.wash_max, { point: false })}{" "}
        {i18n("bet")}.
      </span>
    </div>
  );
};

export default ProgressCard;
